import { useEffect, useState } from "react";

const LABELS = { instagram: "Instagram", twitter: "X", x: "X", facebook: "Facebook", linkedin: "LinkedIn", youtube: "YouTube", tiktok: "TikTok", website: "Website" };

export default function SocialBar() {
  const [links, setLinks] = useState({});
  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL;
    fetch(`${base}/api/public/social`).then((r) => r.json()).then((d) => setLinks(d || {})).catch(() => {});
  }, []);
  const entries = Object.entries(links || {}).filter(([, v]) => v && v.url);
  if (!entries.length) return null;
  return (
    <div className="flex items-center gap-4 flex-wrap" data-testid="social-bar">
      {entries.map(([k, v]) => (
        <a key={k} href={v.url} target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-emerald-400 transition-colors text-sm" data-testid={`social-link-${k}`}>{LABELS[k] || k}</a>
      ))}
    </div>
  );
}
